import service from 'service';

export const getUpgradeRequestList = ({ queryKey: [, params] }) => {
  const url = '/core_subscription/v1/user';
  return service.get(url, { params });
};

export const updateUpgradeRequest = ({ uuid, payload }) => {
  const url = `/core_subscription/v1/user/${uuid}`;
  return service.patch(url, payload);
};
